module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9_3.d8af68b9.png";